import { render } from "./AssessmentTab.vue?vue&type=template&id=68bb9d03&scoped=true"
import script from "./AssessmentTab.vue?vue&type=script&lang=js"
export * from "./AssessmentTab.vue?vue&type=script&lang=js"

import "./AssessmentTab.vue?vue&type=style&index=0&id=68bb9d03&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bb9d03"]])

export default __exports__